/**
 * Store Category Wayfinding Component
 * @module patterns/components/store-category-wayfinding
 */

import { type App } from '~/app';

import JsController from '../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'store category wayfinding');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

export function mountComponent( controller: JsController ) {
    const storeCategoryWayfindings = document.querySelectorAll<HTMLElement>(".store-category-wayfinding");
    for (const storeCategoryWayfinding of storeCategoryWayfindings) {

        const categoryTabs = storeCategoryWayfinding.querySelectorAll<HTMLElement>('.nav-link')
        for (const [index, tab] of categoryTabs.entries()) {   
            
            /** 
             * Shows the selected tab content on click
             */
            const handleTabClick = () => {
                const contentTabs = storeCategoryWayfinding.querySelectorAll<HTMLElement>(`.tab-pane`);
                const navLinks = storeCategoryWayfinding.querySelectorAll<HTMLElement>(".nav-link");
                const activeNavLink = storeCategoryWayfinding.querySelector<HTMLElement>(`#nav-tab-${index}`);
                const activeContentTab = storeCategoryWayfinding.querySelector<HTMLElement>(`#nav-content-${index}`);
                const activeGridTab = storeCategoryWayfinding.querySelector<HTMLElement>(`#nav-grid-${index}`);

                for (const contentTab of contentTabs){
                    contentTab.classList.remove('show', 'active');
                }

                for (const navLink of navLinks){
                    navLink.classList.remove('active');
                }

                activeNavLink?.classList.add('active')
                activeContentTab?.classList.add('show', 'active')
                activeGridTab?.classList.add('show', 'active')
            }

            controller.addListener(tab, "click", handleTabClick);
        }

        const moreCategoriesButton = storeCategoryWayfinding.querySelector<HTMLElement>('.more-categories-button');

        if  (!moreCategoriesButton) {
            return;
        }
        
        /** 
         * Shows more categories when clicked
         */
        const handleMoreCategoriesClick = () => {
            const moreCategories = storeCategoryWayfinding.querySelectorAll<HTMLElement>(".more-categories");
            for (const moreCategory of moreCategories){
                moreCategory.classList.remove('hidden');
            }

            moreCategoriesButton.classList.add('hidden');
        }

        controller.addListener(moreCategoriesButton, "click", handleMoreCategoriesClick);
    }
}
